module.exports = __webpack_public_path__ + "static/ctBg-4bb2ac6dfb75307b79f8b64f44e1061a.jpg";